var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('labels',{attrs:{"value":_vm.labels,"hide-exclude":""},on:{"changed":_vm.submit},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"primary","small":"","disabled":_vm.disabled,"outlined":""}},on),[_vm._v(" "+_vm._s(_vm.btnText))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }